import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import NavCommon from '../../../components/navCommon';
import CardContainerCommon from '../../../components/cardCommon';
import InputCommon from '../../../components/inputCommon';
import {
  Divider,
  Img,
  Info,
  InputBox,
  Margin,
  MarginInput,
  MarginText,
  Row,
  RowFotter,
  Space,
  Title,
} from './styles';
import InputFileCommon from '../../../components/inputFileCommon';
import icons from '../../../constants/icons';
import axios from '../../../services/criterion';
import warn from '../../../constants/toast';
import { Criterios } from '../../../interfaces';
import BackDrop from '../../../components/backDropCommon';

interface CriterionProps {
  criterion: Criterios;
}

const Simple = () => {
  const state = useLocation<CriterionProps>()?.state?.criterion;
  const history = useHistory();
  const [photoBase64, setPhotoBase64] = useState<string>('');
  const [fileName, setNameFile] = useState<string>('');
  const [hasPhoto, setHasPhoto] = useState<boolean>(false);
  const [openDrop, setOpenDrop] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [nameError, setNameError] = useState<boolean>(false);
  const [description, setDescription] = useState<string>('');
  const [descriptionError, setDescriptionError] = useState<boolean>(false);
  const [photoError, setPhotoError] = useState<boolean>(false);
  const [target, setTarget] = useState<string>('');
  const [targetError, setTargetError] = useState<boolean>(false);
  const [pontos, setPoints] = useState<string>('');
  const [pontosError, setPontosError] = useState<boolean>(false);
  const [accumulatedScore, setAccumulatedScore] = useState<boolean>(false);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    populate();
  }, []);

  useEffect(() => {
    if (name) {
      setNameError(false);
    }
    if (description) {
      setDescriptionError(false);
    }
    if (photoBase64) {
      setPhotoError(false);
    }
    if (target) {
      setTargetError(false);
    }
    if (pontos) {
      setPontosError(false);
    }
  }, [photoBase64, name, description, target, pontos]);

  const populate = () => {
    if (state) {
      setName(state.nome);
      setDescription(state.descricao);
      setTarget(state.target.toString());
      setPoints(state.pontos.toString());
      setPhotoBase64(`data:image/png;base64,${state.iconeBase64}`);
      setHasPhoto(true);
      setAccumulatedScore(state.acumulativo);
      setEditMode(true);
    }
  };

  const validation = () => {
    if (!name || !description || !target || !pontos) {
      if (!name) {
        setNameError(true);
      }
      if (!description) {
        setDescriptionError(true);
      }

      if (!pontos) {
        setPontosError(true);
      }
      if (!target) {
        setTargetError(true);
      }
      warn.wargingError('Atenção!\nInforme os dados!');
      return true;
    }
    return false;
  };

  function filterImg(img: String) {
    if (img.includes('jpeg')) {
      return img.replace('data:image/jpeg;base64,', '');
    }
    if (img.includes('png')) {
      return img.replace('data:image/png;base64,', '');
    }
    return '';
  }

  const cleanForm = () => {
    setPhotoBase64('');
    setNameFile('');
    setName('');
    setDescription('');
    setPoints('');
    setTarget('');
    setAccumulatedScore(false);
  };

  const newCriterion = async () => {
    try {
      if (validation()) {
        return;
      }
      setLoading(true);
      await axios.newCriterionSimple(
        name,
        description,
        accumulatedScore,
        filterImg(photoBase64),
        fileName,
        1,
        pontos,
        target,
      );
      cleanForm();
      setLoading(false);
      warn.wargingSuccess('Critério adicionado com sucesso!');
    } catch (error: any) {
      setLoading(false);
      warn.wargingError(`${error?.response?.data?.notifications?.map((item: any) => `${item.message}\n`) || 'Erro status 500!'}`);
    }
  };

  const updateCriterion = async () => {
    try {
      if (validation()) {
        return;
      }
      setLoading(true);
      await axios.updateCriterionSimple(
        state.idCriterio,
        name,
        description,
        accumulatedScore,
        filterImg(photoBase64),
        fileName,
        1,
        pontos,
        target,
      );
      setLoading(false);
      warn.wargingSuccess('Critério atualizado com sucesso!');
    } catch (error: any) {
      setLoading(false);
      warn.wargingError(`${error?.response?.data?.notifications?.map((item: any) => `${item.message}\n`) || 'Erro status 500!'}`);
    }
  };

  const Body = (): any => (
    <>
      {loading && (
        <BackDrop />
      )}
      <Row>
        <InputBox>
          <InputFileCommon
            hasPhoto={hasPhoto}
            setHasPhoto={setHasPhoto}
            onChange={setPhotoBase64}
            onChangeFileName={setNameFile}
            photo={photoBase64}
            isError={photoError}
          />
        </InputBox>
        <Space />
        <InputBox>
          <InputCommon
            isDisabled={false}
            isError={nameError}
            type="text"
            placeholder="Nome"
            value={name}
            onChange={setName}
          />
        </InputBox>
      </Row>
      <MarginInput>
        <InputBox>
          <InputCommon
            isDisabled={false}
            isError={descriptionError}
            type="text"
            placeholder="Descrição"
            value={description}
            onChange={setDescription}
          />
        </InputBox>
      </MarginInput>
      <MarginText>
        <Title>
          Pontuação
        </Title>
      </MarginText>
      <Divider />
      <MarginInput style={{ marginTop: -10 }}>
        <RowFotter>
          <div style={{
            display: 'flex', flexDirection: 'row', width: '70%', alignItems: 'center',
          }}
          >
            <div style={{ width: 200 }}>
              <Info>A cada</Info>
            </div>
            <InputCommon
              isDisabled={false}
              isError={targetError}
              type="number"
              placeholder=""
              value={target}
              onChange={(value: string) => {
                if (value >= '0') {
                  setTarget(value);
                }
              }}
            />
            <Info>Receberá</Info>
            <InputCommon
              isDisabled={false}
              isError={pontosError}
              type="number"
              placeholder=""
              value={pontos}
              onChange={(value: string) => {
                if (value >= '0') {
                  setPoints(value);
                }
              }}
            />
            <Info>Pontos.</Info>
          </div>
          <Row onClick={() => setAccumulatedScore(!accumulatedScore)} style={{ marginTop: 0 }}>
            <Img
              height={16}
              width={16}
              src={accumulatedScore ? icons.checkIcon : icons.unCheckIcon}
            />
            <div style={{ fontFamily: 'Inter', marginLeft: 6, fontSize: 13 }}>Pontuação cumulativa</div>
          </Row>
        </RowFotter>
      </MarginInput>
      <Space />
    </>
  );
  return (
    <>
      <NavCommon
        isSave
        onSave={editMode ? updateCriterion : newCriterion}
        breadcrumbs={[
          { path: '/polipositions', name: 'Pole positions' },
          { path: '/criterios-poleposition', name: 'Critérios' },
          { path: '', name: 'Novo' },
          { path: '', name: 'Simples' },
        ]}
        showDrop={false}
        hasOnChange
        onBack={() => { history.goBack(); }}
        setOpen={setOpenDrop}
        open={openDrop}
        onChange={() => {}}
      />
      <Margin>
        <CardContainerCommon title={editMode ? 'Atualizar Critério' : 'Novo Critério'} childrens={Body()} hasFilter={false} />
      </Margin>
    </>
  );
};
export default Simple;
